import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useSearch, useSort } from '@btime/react-contexts'
import React from 'react'

import { checklistsClient } from '../../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../packages/kiti/components/helpers/LazyAction'
import StatePresenter from '../../../../packages/kiti/components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useChecklistTypesState = () => React.useContext(Context) || {}
export const useChecklistTypes = () => useChecklistTypesState()?.checklistTypes || []

const QUERY = gql`
  query ChecklistTypes($page: Int, $search: String, $sort: ChecklistTypeSort, $filter: ChecklistTypeFilter) {
    checklistTypes(page: $page, search: $search, sort: $sort, filter: $filter) {
      id
      name
      deleted
    }
  }
`

const ChecklistTypesLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const search = useSearch()
  const filter = useCleanFilterForRequest()

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search,
      sort: { field: field || 'NAME', type },
      filter: filter
    },
    client: checklistsClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading} />
      </StatePresenter>
    </Provider>
  )
}

export default ChecklistTypesLoader
